/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Output_Language_HelpInputs */



/**
* | output |
* | --- |
* | "The language the AI will use to write the description text." |
*
* @param {Ad_Output_Language_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_output_language_help = /** @type {((inputs?: Ad_Output_Language_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Output_Language_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le langage que l'IA utilisera pour rédiger le texte descriptif.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Sprache, die die KI zum Schreiben des Beschreibungstextes verwenden wird.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La lingua che l'IA utilizzerà per scrivere il testo descrittivo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Язык, который ИИ будет использовать для написания описательного текста.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El idioma que la IA utilizará para escribir el texto descriptivo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("人工智能将用于编写描述文本的语言。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIが説明文を作成する際に使用する言語。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वह भाषा जिसका उपयोग एआई विवरण लिखने के लिए करेगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O idioma que a IA usará para escrever o texto descritivo.")
	return /** @type {LocalizedString} */ ("The language the AI will use to write the description text.")
});